{
  "version": 1,
  "asset_id": "a9edf1f6-3ee6-40f8-96ab-6f5a7578c3d3",
  "project_id": "d3d6c30c-5e9b-4177-897c-1c6e2a8b33af",
  "url": "/__l5e/assets-v1/a9edf1f6-3ee6-40f8-96ab-6f5a7578c3d3/mae-to-no-beedoo.png",
  "r2_key": "a/v1/d3d6c30c-5e9b-4177-897c-1c6e2a8b33af/a9edf1f6-3ee6-40f8-96ab-6f5a7578c3d3/mae-to-no-beedoo.png",
  "original_filename": "mae-to-no-beedoo.png",
  "size": 124302,
  "content_type": "image/png",
  "created_at": "2026-07-28T15:21:27Z"
}
